import { FC } from "react";
import { Link } from "react-router-dom";
import { Box } from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { useStyles } from "./styles";

interface Props {
  label: string;
  link: string;
}

const ExternalLink: FC<Props> = ({ label, link }) => {
  const classes = useStyles();

  return (
    <Box className={classes.linkWrapper}>
      <Link className={classes.link} to={link}>
        <Box className={classes.linkText}>{label}</Box>
        <Box className="link-icon">
          <KeyboardArrowRightIcon fontSize="small" />
        </Box>
      </Link>
    </Box>
  );
};

export default ExternalLink;
